import { CSSTransition } from 'react-transition-group';

import { SignInForm } from '@/shared/components/account/signForms/SignInForm';
import { RemindPassword } from '../../../signForms/RemindPassword';

import { SignInTabsProps } from './types';
import styles from './SignInTab.module.scss';
import { useBasket } from '@/shared/context/basket-context';
import { ChangePassword } from '../../../signForms/ChangePassword';

export const SignInTab = ({
	active,
	changePasswordActive,
	remindPasswordActive,
	backToLoginPress,
	setChangePasswordActive,
	setRemindPasswordActive,
	onAuthModalClose,
}: SignInTabsProps) => {
	const { setIsLoginModalOpen } = useBasket();

	const handleModalClose = () => {
		if (onAuthModalClose) {
			onAuthModalClose();
			return;
		}

		setIsLoginModalOpen(false);
	};

	return (
		<CSSTransition
			in={active}
			timeout={{ enter: 500, exit: 0 }}
			classNames={{
				enter: styles['signIn__transition-enter'],
				enterActive: styles['signIn__transition-enter-active'],
				exit: styles['signIn__transition-exit'],
				exitActive: styles['signIn__transition-exit-active'],
			}}
			unmountOnExit
		>
			<div className={styles.signIn__container}>
				{remindPasswordActive ? (
					<RemindPassword backToLoginPress={backToLoginPress} />
				) : changePasswordActive ? (
					<ChangePassword
						changePasswordActive={changePasswordActive}
						setChangePasswordActive={setChangePasswordActive}
					/>
				) : (
					<SignInForm
						setRemindPasswordActive={setRemindPasswordActive}
						handleModalClose={handleModalClose}
						setChangePasswordActive={setChangePasswordActive}
					/>
				)}
			</div>
		</CSSTransition>
	);
};
